import { Injectable } from '@angular/core';
import { LiveAvailability } from '@cigna/omni/data-access';
import { Store, select } from '@ngrx/store';
import {
  GetLiveAvailability,
  GetLiveAvailabilitySuccess,
} from './live-availability.actions';
import { LiveAvailabilityState } from './live-availability.reducer';
import { liveAvailabilityQuery } from './live-availability.selectors';

@Injectable()
export class OmniLiveAvailabilityFacade {
  liveChatAvailable$ = this.store$.pipe(
    select(liveAvailabilityQuery.getLiveChatAvailable),
  );

  chatCloseHrsMsg$ = this.store$.pipe(
    select(liveAvailabilityQuery.getChatCloseHrsMsg),
  );

  constructor(private store$: Store<LiveAvailabilityState>) {}

  setLiveAvailability(liveAvailability: LiveAvailability) {
    this.store$.dispatch(new GetLiveAvailabilitySuccess(liveAvailability));
  }
}
